import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { createScopedI18n } from '@application/utilities/i18n';
import { useEventRegistrationLanguage } from './hooks/useEventRegistrationLanguage';
const EventRegistrationLanguageContext = createContext(null);
export const EventRegistrationLanguageProvider = ({ children, embeddedPreview = false }) => {
    // Registration language lives in its own i18n instance so switching it never changes
    // (or persists) the admin app's language.
    const [registrationI18n] = useState(() => createScopedI18n());
    const value = useEventRegistrationLanguage({ embeddedPreview, i18n: registrationI18n });
    return (_jsx(I18nextProvider, { i18n: registrationI18n, children: _jsx(EventRegistrationLanguageContext.Provider, { value: value, children: children }) }));
};
export const useEventRegistrationLanguageContext = () => {
    const context = useContext(EventRegistrationLanguageContext);
    if (!context) {
        throw new Error('useEventRegistrationLanguageContext must be used within EventRegistrationLanguageProvider');
    }
    return context;
};
export const useOptionalEventRegistrationLanguageContext = () => useContext(EventRegistrationLanguageContext);
